import { navigate, RouteComponentProps } from '@reach/router';
import { AppPath } from 'appConstants';
import React, { useEffect, useState } from 'react';
import { accessInformation, ISubscription, SubscriptionsList } from './models';
import Page from 'components/shared/Page';
import { UpgradeSubscriptions } from './UpgradeSubscriptions';
import { Spinner } from 'components/spinner/Spinner';
import { SubscriptionsApi } from 'api/subscriptionsApi';
import { RenewSubscriptionsForm } from './RenewSubscriptionsForm';

export const Subscriptions: React.FC<RouteComponentProps> = () => {
  const [isUpgradeMenuOpen, setIsUpgradeMenuOpen] = useState<boolean>(false);
  const [isRenewMenuOpen, setIsRenewMenuOpen] = useState<boolean>(false);

  const [selectedSubscription, setSelectedSubscription] = useState<
    number | null
  >(null);
  const [selectedSubject, setSelectedSubject] = useState<number | null>(null);
  const [sideMenuTitle, setSideMenuTitle] = useState('');
  const [updateList, setUpdateList] = useState(true);
  const [accessInfo, setAccessInfo] = useState<accessInformation | null>(null);
  const [subscriptionsListInfo, setSubscriptionsListInfo] =
    useState<SubscriptionsList | null>(null);
  const [error, setError] = useState<string>('');

  const fetchSubscriptionsList = async () => {
    const result = await SubscriptionsApi.getSubscriptionsList();

    if (result.data) {
      const { listSubscriptions, bCanAddFreeTrial, bCanAddSubscription } =
        result.data;
      setSubscriptionsListInfo(listSubscriptions ? listSubscriptions : []);
      setAccessInfo({ bCanAddFreeTrial, bCanAddSubscription });
    }

    if (result.error) {
      setError(result.error);
    }
  };

  useEffect(() => {
    if (!updateList) return;
    fetchSubscriptionsList();
    setUpdateList(false);
  }, [updateList]);

  const handleNewSubscription = () => {
    navigate(AppPath.NEW_SUBSCRIPTION);
  };

  const handleNewFreeTrial = () => {
    navigate(AppPath.NEW_FREE_TRIAL);
  };

  const handleUpgradeMenuOpen = (title: string, id: number) => {
    setSideMenuTitle(title);
    setSelectedSubscription(id);
    setIsUpgradeMenuOpen(true);
  };

  const handleRenewMenuOpen = (
    title: string,
    id: number,
    packageID: number
  ) => {
    setSideMenuTitle(title);
    setSelectedSubject(id);
    setIsRenewMenuOpen(true);
    setSelectedSubscription(packageID);
  };

  return (
    <Page>
      <div className="PageContent SubscriptionsPage WidthContent">
        <div className="TitleBar">
          <h1 className="PageTitle">Subscriptions</h1>
          <div className="SubscriptionsButtonContainer">
            {subscriptionsListInfo &&
              subscriptionsListInfo?.length !== 0 &&
              accessInfo?.bCanAddFreeTrial && (
                <button
                  className="Btn BtnLightOrange NewSubscriptionButton"
                  onClick={handleNewFreeTrial}
                >
                  <span className="Plus">+</span>
                  <span className="Text">Add a free trial</span>
                </button>
              )}
            {subscriptionsListInfo &&
              subscriptionsListInfo?.length !== 0 &&
              accessInfo?.bCanAddSubscription && (
                <button
                  className="Btn BtnLightOrange NewFreeTrial"
                  onClick={handleNewSubscription}
                >
                  <span className="Plus">+</span>
                  <span className="Text">Add a new subscription</span>
                </button>
              )}
          </div>
        </div>
        {!subscriptionsListInfo && !error && (
          <div className="PageSpinner">
            <Spinner />
          </div>
        )}
        {subscriptionsListInfo && subscriptionsListInfo?.length === 0 && (
          <div className="MsgContainer">
            <div className="Txt">Ready to get started?</div>
            <div className="MsgContainerButtons">
              {accessInfo?.bCanAddFreeTrial && (
                <button
                  className="Btn BtnLightOrange NewSubscriptionButton"
                  onClick={handleNewFreeTrial}
                >
                  <span className="Plus">+</span>
                  <span className="Text">Add a free trial</span>
                </button>
              )}
              {accessInfo?.bCanAddSubscription && (
                <button
                  className="Btn BtnLightOrange NewFreeTrial"
                  onClick={handleNewSubscription}
                >
                  <span className="Plus">+</span>
                  <span className="Text">Add a new subscription</span>
                </button>
              )}
            </div>
          </div>
        )}
        <div className="GridSection">
          {subscriptionsListInfo &&
            subscriptionsListInfo.map((sub: ISubscription) => (
              <div
                className="GridTile GridImageTile"
                key={sub.subject + sub.subscription}
              >
                <div className="TileBody">
                  <div className="TileTitleBar">
                    <h2 className="TileTitle">{sub.subject}</h2>
                    {/*<p className="Price">£{sub.price}</p>*/}
                  </div>
                  <p className="TileSubtitle">{sub.subscription}</p>
                  <div className="TileSmallTextContainer">
                    <p className="TileSmallText">
                      From {sub.fromDate} to {sub.toDate}
                    </p>
                    <p className="TileSmallText">
                      Renewal date {sub.renewalDate}
                    </p>
                  </div>
                  {/*Client requested the upgrade process to be hidden*/}
                  {/* {sub.isUpgradable && (
                    <button
                      onClick={() =>
                        handleUpgradeMenuOpen(
                          'Upgrade subscription',
                          sub.subjectId
                        )
                      }
                      className="Btn BtnOrange TileButton"
                    >
                      Upgrade subscription
                    </button>
                  )} */}
                  {sub.isRenewable && (
                    <button
                      onClick={() =>
                        handleRenewMenuOpen(
                          'Renew subscription',
                          sub.subjectId,
                          sub.id
                        )
                      }
                      className="Btn BtnOrange TileButton"
                    >
                      Renew subscription
                    </button>
                  )}
                </div>
              </div>
            ))}
        </div>
        {/* Upgrade subscription */}
        {isUpgradeMenuOpen && selectedSubscription && (
          <UpgradeSubscriptions
            panelOpen={isUpgradeMenuOpen}
            togglePanelOpen={setIsUpgradeMenuOpen}
            menuTitle={sideMenuTitle}
            id={selectedSubscription}
            setUpdateList={setUpdateList}
          />
        )}
        {/* Renew subscription */}
        {isRenewMenuOpen && selectedSubject && selectedSubscription && (
          <RenewSubscriptionsForm
            panelOpen={isRenewMenuOpen}
            togglePanelOpen={setIsRenewMenuOpen}
            menuTitle={sideMenuTitle}
            id={selectedSubject}
            setUpdateList={setUpdateList}
            packageId={selectedSubscription}
          />
        )}
      </div>
    </Page>
  );
};
